/* eslint-disable @typescript-eslint/no-explicit-any */
import { first, switchMap } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ActivatedRouteSnapshot } from '@angular/router';

import { CheckoutState, checkoutQuery, fromCheckoutActions } from '../+state';

@Injectable()
export class QuoteResolver {
  constructor(private _store: Store<CheckoutState>) {}

  /*
   * Resolve QuotToSend
   * 1. Selects QuotToSend from the store
   * 2. Checks QuotToSend.quoteId is present
   *    -If it doesn't exist:
   *    1. GetQuotToSend with :quoteId
   * 3. Checks paramQuoteUuid from url with present quoteId
   *    - If it doesn't match:
   *    1. GetQuotToSend with :quoteId
   *    - If it does match:
   *    1. Return getQuotToSend from Store
   */
  public resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this._store.pipe(select(checkoutQuery.getQuoteToSend), first()).pipe(
      switchMap(() => {
        // TODO
        // for now we cannot use cached data
        // there is no delta sync/realtime infrastructure
        const paramQuoteUuid = route.params.quoteId;
        this.getQuoteToSend(paramQuoteUuid);
        return of(true);

        // if (!selectedQuote) {
        //   return this.getQuoteToSend(paramQuoteUuid);
        // }

        // if (paramQuoteUuid !== selectedQuote.quoteUuid) {
        //   return this.getQuoteToSend(paramQuoteUuid);
        // }

        // return of(selectedQuote);
      })
    );
  }

  /*
   * trigger fetching quote to send
   * 1. Dispatch getQuoteToSend action
   * 2. Listening to setQuoteToSend
   * 3. Return payload of setQuoteToSend
   */
  private getQuoteToSend(id: string) {
    this._store.dispatch(fromCheckoutActions.getQuoteToSend({ payload: { id } }));
  }
}
